<template>
  <div class="text-right">
    <v-dialog
      v-model="dialog"
      width="500"
    >
      <template v-slot:activator="{ on }">
        <v-btn
          color="wrld_red"
          dark
          v-on="on"
        >
          {{$t('buttons.remove')}}
        </v-btn>
      </template>

      <v-card>
        <v-card-title
          class="headline"
          primary-title
        >
          {{$t('buttons.remove')}}
        </v-card-title>
        <!-- <v-divider></v-divider> -->
        <v-card-text
        class="title mt-4 mb-3"
        >
          {{$t('organizations.remove_contact_person_confirm_message')}}
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="dialog = false"
          >
            {{$t('buttons.cancel')}}
          </v-btn>
          <v-btn
            color="wrld_red"
            dark
            @click="handleDelete"
          >
          <span
          v-if="!isLoading"
          class="text--white"
          >
            {{$t('buttons.delete')}}
          </span>
          <v-progress-circular
            v-else
            size="20"
            width="3"
            indeterminate
            color="white"
        ></v-progress-circular>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
  import { mapActions, mapGetters } from 'vuex'
  export default {
    name: 'RemoveContactPerson',
    props: {
      contact: { type: Object, default: () => null }
    },
    data() {
      return {
        dialog: false,
        isLoading: false
      }
    },
    methods: {
      ...mapActions({
        removeContactPersonManagedOrganization: 'removeContactPersonManagedOrganization',
        removeSecondResourceOverviewListItem: 'removeSecondResourceOverviewListItem',
        selectResourceSecond: 'selectResourceSecond'
      }),
      handleDelete () {
        this.isLoading = true
        this.removeContactPersonManagedOrganization({ contact: this.contact })
        this.removeSecondResourceOverviewListItem({ item: this.contact })
        this.selectResourceSecond(null)
      }
    },
    computed: {
      ...mapGetters([
        'getOrganizationIsUpdating'
      ])
    },
    watch: {
      getOrganizationIsUpdating: {
        deep: true,
        handler (val, oldVal) {
          if (oldVal && !val) {
            this.isLoading = false
            this.dialog = false
          }
        }
      },
    },
  }
</script>

<style lang="scss" scoped>

</style>
